import React, { useState, useMemo } from 'react'
import { dateCol, strCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from '../admin/component/CommonScreen'
import { UtilityUnitSelection } from 'core'
import { connect } from 'react-redux'
import { DatePicker, Select, Button, Input } from 'antd'
import { Label } from 'core/screen-util'
import {
  modifiedDateCol,
  modifierCol,
  utilityHeader,
  unitIdHeader,
  YNBooleanTypes,
} from 'core/HeaderColTypeProps'
import { getUtilityNameMap, getUnitNameMap } from 'core/selectors'
import {
  getVerificationPnode,
  deleteVerificationPnode,
  saveVerificationPnode,
} from '../api/pgads'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'

const title = 'Verification Pnode'

const VerificationPnode = ({ utilityNameMap, unitNameMap }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const headerWithFormatter = useMemo(
    _ =>
      VerificationPnodeHeaders.map(h =>
        h.ident === 'utility'
          ? {
              ...h,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : h.ident === 'unitId'
          ? {
              ...h,
              choices: [],
              // dataGetter: generateDataGetter,
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unit] || rowData.unit,
            }
          : h
      ),
    [unitNameMap, utilityNameMap]
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <table
      style={{
        width: '100%',
        borderSpacing: '10px',
        borderCollapse: 'inherit',
      }}
    >
      <tbody>
        <tr>
          <td style={{ width: '100px' }}>
            <Label>Utility / Unit : </Label>
          </td>
          <td style={{ minWidth: '600px' }} colSpan="3">
            <UtilityUnitSelection
              utility={insertData.utility}
              unit={insertData.unitId}
              onUnitChange={value => {
                // setUtilityUnit(value)
                setInsertData({
                  ...insertData,
                  utility: value[0],
                  unitId: value[1],
                  unit: value[1].substr(3),
                })
              }}
            />
          </td>

          <td>
            <Label>Effective Date : </Label>
          </td>
          <td>
            <DatePicker
              allowClear={false}
              format="MM/DD/YYYY"
              value={insertData.effectiveDateMom}
              onChange={date => {
                setInsertData({
                  ...insertData,
                  effectiveDateMom: date,
                  effectiveDate: date.format('YYYY-MM-DD'),
                })
              }}
            />
          </td>
        </tr>
        <tr>
          <td>
            <Label>Pnode Id : </Label>
          </td>
          <td>
            <Input
              style={{ width: '200px' }}
              value={insertData.pnodeId}
              onChange={e =>
                setInsertData({ ...insertData, pnodeId: e.target.value })
              }
              maxLength={15}
            />
          </td>
          <td colSpan={3}>
            <Label>Aggregate : </Label>
          </td>
          <td>
            <Select
              style={{ width: '100px' }}
              value={insertData.aggregate}
              onChange={e => setInsertData({ ...insertData, aggregate: e })}
            >
              <Select.Option key="Y">Yes</Select.Option>
              <Select.Option key="N">No</Select.Option>
            </Select>
          </td>
          <td>
            <Button type="primary" onClick={() => onAdd(true)}>
              Add
            </Button>
          </td>
          <td>
            <Button type="primary" onClick={() => onAdd(false)}>
              Add & Hide
            </Button>
          </td>
          <td>
            <Button type="danger" onClick={onCancel}>
              Cancel
            </Button>
          </td>
        </tr>
      </tbody>
    </table>
  )

  return (
    <CommonScreen
      withUnitSelection={false}
      isAdminScreen
      title={title}
      header={headerWithFormatter}
      saveTask={saveVerificationPnode}
      retrieveTask={getVerificationPnode}
      deleteTask={deleteVerificationPnode}
      altBy={d => d.unitId}
      autoRetrieve
      sortOptions={VerificationPnodeHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={insertEvent && insertComp}
      onInsertEvent={b => setInsertEvent(b)}
      insertCompHeight={0}
      autoFixColByKey={false}
      headerRowHeight={60}
    />
  )
}

const mapStateToProps = state => ({
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(VerificationPnode)

export const VerificationPnodeHeaders = [
  utilityHeader,
  unitIdHeader,
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'pnodeId',
    display: 'Pnode Id',
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'aggregate',
    display: 'Aggregate',
    sortOrder: 'asc',
    ...toSelectionColProps(YNBooleanTypes),
  }),
  modifierCol,
  modifiedDateCol,
]
